import { DragDropContext } from "@hello-pangea/dnd";
import { useMemo } from "react";
import { globalDragNDropContext } from "./context";
import { useGlobalDragNDrop } from "./logics";
import type { IGlobalDragNDropProps } from "./types";

export const GlobalDragNDrop = ({ children }: IGlobalDragNDropProps) => {
  const { onDragStart, onDragUpdate, onDragEnd, ...registers } = useGlobalDragNDrop();

  const contextValue = useMemo(() => registers, []);

  return (
    <DragDropContext onDragStart={onDragStart} onDragUpdate={onDragUpdate} onDragEnd={onDragEnd}>
      <globalDragNDropContext.Provider value={contextValue}>{children}</globalDragNDropContext.Provider>
    </DragDropContext>
  );
};

export { GlobalDroppable } from "./droppable";
export { useGlobalDragNDropEvent } from "./logics";
export type { IGlobalDragNDropEvent, IGlobalDroppableBooleanOptions } from "./types";
